// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"4697ea3f72e4ad44","2939":"79fa4f42c92d1a60","4511":"79fa4f42c92d1a60","4760":"6131f37e9d2bd3c9","8169":"79fa4f42c92d1a60"}[chunkId] + ".css";
};